import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import Formsy from "formsy-react";
import withPriceAlertsModal from "../../../../../hocs/withPriceAlertsModal";
import { compose } from "redux";
import NewModal from "../../NewModal";
import withTranslations from "../../../../../hocs/withTranslations";
import FormBuilderWeb from "../../../../../lib/FormBuilder/FormBuilderWeb";
import useIsDesktop from "../../../landingPage/hooks/useIsDesktop";
import classNames from "classnames";
import PriceAlertsTable from "../../../pages/SingleAnalysisPage/components/PriceAlertsTable/PriceAlertsTable";

const NewPriceAlertModal = ({
  hideModal,
  translate,
  formBuilder,
  addAlert,
  renewAlert,
  price,
  setPrice,
  description,
  setComment,
  stockId,
  editingAlertId,
  stockName
}) => {
  const isDesktop = useIsDesktop();
  const formRef = useRef(null);
  const isEditingAlert = editingAlertId != null;

  useEffect(() => {
    setPrice(price);
  }, [price]);

  useEffect(() => {
    setComment(description);
  }, [description]);

  return (
    <NewModal
      hideModal={hideModal}
      title={translate(
        isEditingAlert
          ? "new-price-alert-modal_edit-title"
          : "new-price-alert-modal_title"
      )}
      onAccept={() => {
        formRef.current?.submit?.();
      }}
      onCancel={() => {
        formBuilder?.clear?.();
      }}
      acceptButtonText={translate(
        isEditingAlert
          ? "new-price-alert-modal_edit-accept-button"
          : "new-price-alert-modal_accept-button"
      )}
      cancelButtonText={translate("new-price-alert-modal_cancel-button")}
    >
      <p
        className={classNames("text-black-5 line-height-130 mb-4", {
          "text-sm": !isDesktop,
          "text-xs": isDesktop
        })}
      >
        {translate("new-price-alert-modal_description")}
      </p>
      <h2 className={"text-black font-medium text-sm mb-4"}>
        {translate("new-price-alert-modal_subtitle")}
      </h2>
      <Formsy
        ref={element => (formRef.current = element)}
        onValidSubmit={() => {
          if (isEditingAlert) {
            renewAlert({
              id: editingAlertId,
              value: formBuilder.fields[0].value,
              comment: formBuilder.fields[1].value,
              stockId
            });
            hideModal();
            return;
          }

          addAlert({
            fields: formBuilder.fields,
            form: formRef.current,
            clearFormBuilder: formBuilder.clear
          });
        }}
      >
        <div className={"mb-6"}>
          <FormBuilderWeb
            {...formBuilder}
            className={"flex flex-col gap-5 mb-6"}
          />
        </div>
      </Formsy>
      <div className={"flex flex-col gap-6"}>
        <p
          className={classNames("text-black-5 line-height-130 mb-0", {
            "text-sm": !isDesktop,
            "text-xs": isDesktop
          })}
          dangerouslySetInnerHTML={{
            __html: translate("new-price-alert-modal_hint-html")
          }}
        />
        <PriceAlertsTable stockId={stockId} stockName={stockName} />
      </div>
    </NewModal>
  );
};

export default compose(
  withPriceAlertsModal,
  withTranslations
)(NewPriceAlertModal);
